export default __webpack_public_path__ + "static/media/logo-vodafone.64bd2eee.svg";